function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { CacheProvider, ThemeProvider, useTheme } from '@emotion/react';
import createCache from '@emotion/cache';
import PropTypes from 'prop-types';
import { useFeatureFlags } from '../../utilities/feature-flags';
var cache = createCache({
  key: 'mesh',
  prepend: true
});
var propTypes = {
  children: PropTypes.node
};
var defaultProps = {
  children: /*#__PURE__*/React.createElement(React.Fragment, null)
};
var StyledCacheWrapper = function StyledCacheWrapper(_ref) {
  var children = _ref.children;
  // check for enabled feature flags
  var enabledFeatureFlags = useFeatureFlags();
  // get current emotion theme (feature flags will be added to theme)
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: _objectSpread(_objectSpread({}, enabledFeatureFlags), theme)
  }, /*#__PURE__*/React.createElement(CacheProvider, {
    value: cache
  }, children));
};
StyledCacheWrapper.propTypes = propTypes;
StyledCacheWrapper.defaultProps = defaultProps;
export default StyledCacheWrapper;